function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.8 75.2h37c.5 0 .7-.2.7-.7V.7c0-.5 0-.7.7-.6 3.6.4 7.1 1 10.5 1.9 5.2 1.4 10.2 3.4 14.9 5.9 3.6 1.9 6.9 4.1 10.1 6.6 1.7 1.4 3.3 2.8 4.9 4.3 1.6 1.5 3.1 3.1 4.5 4.7 3.1 3.6 5.9 7.5 8.2 11.6 2.1 3.7 3.8 7.6 5.2 11.6 1.3 3.9 2.3 7.9 2.9 12 .3 2.3.6 4.7.7 7 .1 1.9.1 3.8 0 5.7-.2 4.3-.7 8.5-1.6 12.6-.7 3.2-1.7 6.4-2.9 9.5-.3.7-.3.7-.9.4-5.2-2.5-10.5-4.9-16-6.7-3.8-1.2-7.7-2.1-11.7-2.6-3.4-.4-6.8-.5-10.2-.4-5.1.2-10.2 1.1-15.1 2.6-3.2 1-6.4 2.3-9.5 3.7-4.6 2-9.2 4.2-14 5.7-3.2 1-6.4 1.7-9.8 2.2-1.9.2-3.8.4-5.7.5-4.3.2-8.4-.4-12.6-1.3-4.3-.9-8.4-2.3-12.5-4-4.9-2-9.5-4.5-13.7-7.8-.2-.2-.3-.4-.4-.6-.8-3.1-1.3-6.3-1.6-9.4-.1-.5.2-.6.6-.6h37.3z",
  className: "ship-color"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.6 94c.6.4 1.1.7 1.6 1 3 1.9 6.2 3.5 9.4 4.8 3.7 1.6 7.6 2.8 11.5 3.8 3 .7 6 1.2 9.1 1.4 5.2.3 10.4-.2 15.5-1.3 4-.9 7.9-2.3 11.7-3.9 4.3-1.8 8.5-3.9 12.8-5.5 4.1-1.5 8.3-2.7 12.6-3.3 2.1-.3 4.2-.5 6.3-.6 5.6-.3 11.2.4 16.7 1.7 4.4 1.1 8.7 2.6 12.8 4.4l6 2.7c.3.1.3.3.2.5-1 2-2.1 3.9-3.2 5.8-1.4 2.2-2.9 4.3-4.5 6.4-1 1.2-2 2.4-3 3.5-.9 1-1.8 1.9-2.8 2.9-2.8 2.8-5.8 5.2-9.1 7.5-3 2.1-6.1 3.9-9.4 5.5-3.9 1.8-7.8 3.3-12 4.4-3.3.9-6.7 1.5-10 1.9-1.8.2-3.6.3-5.4.4-1.3.1-2.5.1-3.8 0-3.1-.1-6.2-.3-9.2-.8-3.8-.6-7.5-1.5-11.1-2.6-4-1.3-7.8-3-11.5-5-3.3-1.8-6.4-3.9-9.4-6.2-1.4-1.1-2.8-2.2-4.1-3.4-1.6-1.5-3.1-3-4.6-4.6-2.6-2.8-4.9-5.8-6.9-9-2.4-3.8-4.5-7.7-6.2-11.9.1 0 .1-.2 0-.5z",
  className: "ship-color"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M52.1 46.4v-.7-24.3c0-.7 0-.7-.6-.4-12.1 4.8-21.4 12.9-27.7 24.3-2.6 4.7-4.4 9.8-5.5 15.1-.5 2.5-.9 5.1-.9 7.7 0 1.2-.1 1.2-1.2 1.2H.7c-.6-.1-.7-.2-.7-.7C.2 55.4 3.8 43.1 10.9 32c7.2-11.2 16.8-19.6 28.8-25.3C45 4.2 50.6 2.4 56.4 1.3c3.3-.6 6.6-1 10-1.1.8 0 1.7 0 2.5-.1.4 0 .5.1.4.4v68.1c0 .6-.2.7-.7.7H52.5c-.4 0-.6-.1-.9-.3-4.1-3.6-8.2-7.2-12.3-10.9-3.8-3.3-7.5-6.6-11.3-9.9-.3-.3-.3-.5-.1-.8 2-3.7 4.5-6.9 7.4-9.9.9-1 1.9-1.9 2.9-2.9.2-.2.4-.2.6 0l12.6 11.1.7.7z",
  className: "text-color"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 138.3 138.1",
    className: "arkas-logo"
  }, props), _ref, _ref2, _ref3);
};

export default SvgComponent;